<template>
    <label :class="size" class="ui-input input-value-to-percent">
        <div v-if="label" class="label">
            <span v-html="label"></span>
            <span class="label-required" v-if="required">*</span>
        </div>

        <div class="content">
            <div class="input-group">
                <ui-input-money
                    v-model="datavalue"
                    v-bind="moneyConfig"
                    :disabled="disabled || disabledValue"
                    prefix=''
                    group />
            </div>

            <div class="input-group">
                <span class="equal-sign" :class="{'disabled': disabled}">=</span>
                <div class="ui-input-group">
                    <input v-number
                        v-model="datapercent"
                        :disabled="disabled || disabledPercent"
                        class="input"
                        type="tel"
                        autocomplete="off"
                        ref="percent" />
                    <span class="group">%</span>
                </div>
            </div>
        </div>
    </label>
</template>

<script>
    import uiInputMoney from '../input-money'
    import { number } from '@/directives'

    export default {
        components: {
            uiInputMoney,
        },

        directives: {
            number,
        },

        props: {
            /**
             * Defines the displayed monetary value
             */
            value: {
                type: [Number, String],
                required: true,
                default: 0
            },

            /**
             * Sets the percentage value displayed
             */
            percent: {
                type: [Number, String],
                required: false,
                default: 0
            },

            /**
             * Use to apply the button classes
             */
            label: {
                type: String,
                required: false,
            },

            /**
             * Use to change the size of the input
             */
            size: {
                type: String,
                required: false,
                default: 'md'
            },

            /**
             * Use to disable input
             */
            disabled: {
                type: Boolean,
                required: false,
                default: false
            },

            /**
             * Use to disable input
             */
            disabledValue: {
                type: Boolean,
                required: false,
                default: false
            },

            /**
             * Use to disable input
             */
            disabledPercent: {
                type: Boolean,
                required: false,
                default: false
            },

            /**
             * define the input as required in html5 and apply the '*' operator to the label
             */
            required: {
                type: Boolean,
                required: false,
                default: false
            },
        },

        data() {
            return {
                moneyConfig: {
                    decimal: ',',
                    thousands: '.',
                    prefix: 'R$ ',
                    suffix: ' ',
                    precision: 2,
                    masked: false
                }
            }
        },

        computed: {
            datavalue: {
                get() {
                    return parseFloat(this.value)
                },
                set(value) {
                    this.$emit('update:value', parseFloat(value) || 0)
                    this.update()
                }
            },

            datapercent: {
                get() {
                    return parseFloat(this.percent)
                },
                set(value) {
                    this.$emit('update:percent', value || 0)
                    this.update()
                }
            }
        },

        methods: {
            /**
             * Emits an event as soon as any change in any of the inputs occurs
             */
            update() {
                let data = {
                    value: this.datavalue,
                    percent: this.datapercent
                }

                this.$nextTick()
                this.$emit('change', data)
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>